import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Input } from 'ui-components/components/input';
import { SHORT_ANSWER_QUESTION, DROPDOWN_QUESTION } from '../../../constants';
import { usePaymentAndSubscriptionPageContext } from '../../../context/payment-and-subscription-page-context';
import { followUpCancelReasonMap, followUpReasons } from '../../../messages';
import { CancelReasonDataPropType, CancelReasonPropType } from '../prop-types';
import style from '../../../style.module.less';

const FollowUpDropdownValue = ({ reasonData }) => {
  const intl = useIntl();
  const { followUpCancelReasonId, setFollowUpCancelReasonId } = usePaymentAndSubscriptionPageContext();
  const { cancelSubReasons = [] } = reasonData?.cancelFollowUpQuestions[0] || {};
  const completeCancelSubReasons = [{ cancelSubReasonId: 0 }, ...cancelSubReasons];

  return (
    <DropdownMenu className={style['cancellation-dropdown']}>
      <DropdownMenuToggler className={style['cancellation-dropdown']} theme='white'>
        <FormattedMessage {...followUpReasons[followUpCancelReasonId]} />
      </DropdownMenuToggler>
      {completeCancelSubReasons.map(({ cancelSubReasonId: rId }) => {
        return (
          <DropdownMenuItem key={rId} name={rId} onClick={setFollowUpCancelReasonId} value={rId}>
            {intl.formatMessage(followUpReasons[rId])}
          </DropdownMenuItem>
        );
      })}
    </DropdownMenu>
  );
};

FollowUpDropdownValue.propTypes = {
  reasonData: CancelReasonPropType,
};

const FollowUpCancellationReasonDropdown = ({ cancelReasonData }) => {
  const { cancelReasonId, followUpExplain, setFollowUpExplain } = usePaymentAndSubscriptionPageContext();
  return (
    <>
      <div className={style['cancellation-label']}>
        <FormattedMessage {...followUpCancelReasonMap[cancelReasonId]} />
      </div>
      {cancelReasonData[cancelReasonId]?.cancelFollowUpQuestions[0].answerTypeId === SHORT_ANSWER_QUESTION && (
        <Input onChange={setFollowUpExplain} value={followUpExplain} />
      )}
      {cancelReasonData[cancelReasonId]?.cancelFollowUpQuestions[0].answerTypeId === DROPDOWN_QUESTION && (
        <FollowUpDropdownValue reasonData={cancelReasonData[cancelReasonId]} />
      )}
    </>
  );
};

FollowUpCancellationReasonDropdown.propTypes = {
  cancelReasonData: CancelReasonDataPropType,
};

export default FollowUpCancellationReasonDropdown;
